import i18n from "i18next"

export function injectJsonLd(id: string, data: object): () => void {
  let el = document.querySelector<HTMLScriptElement>(`script[data-ld="${id}"]`)
  if (!el) {
    el = document.createElement("script")
    el.type = "application/ld+json"
    el.setAttribute("data-ld", id)
    document.head.appendChild(el)
  }
  el.textContent = JSON.stringify(data)
  const captured = el
  return () => captured.remove()
}

const SITE = "https://pawseum.com"

export function buildAnimalJsonLd(
  animal: {
    name: string
    breed?: string
    description?: string
    photo_url?: string
    status: string
    id: string
    kennel?: { city?: string }
    particular?: { city?: string }
  },
  animalType: "cao" | "gato",
  slug: string,
) {
  const breed = animal.breed ?? ""
  const cityStr = animal.kennel?.city ?? animal.particular?.city
  return {
    "@context": "https://schema.org",
    "@type": animalType === "cao" ? "Dog" : "Cat",
    name: animal.name,
    ...(breed ? { breed: { "@type": "BreedType", name: breed } } : {}),
    description: animal.description,
    image: animal.photo_url,
    url: `${SITE}/${animalType}/${slug}-${animal.id}`,
    ...(cityStr ? { locationCreated: { "@type": "Place", addressLocality: cityStr, addressCountry: "PT" } } : {}),
    offers: {
      "@type": "Offer",
      price: "0",
      priceCurrency: "EUR",
      availability: animal.status === "DISPONIVEL"
        ? "https://schema.org/InStock"
        : "https://schema.org/SoldOut",
    },
  }
}

export function buildKennelJsonLd(
  kennel: {
    name: string
    description?: string
    city?: string
    phone?: string
    email?: string
    image?: string
  },
  slug: string,
) {
  return {
    "@context": "https://schema.org",
    "@type": "AnimalShelter",
    name: kennel.name,
    description: kennel.description,
    url: `${SITE}/canis/${slug}`,
    ...(kennel.city ? { address: { "@type": "PostalAddress", addressLocality: kennel.city, addressCountry: "PT" } } : {}),
    ...(kennel.phone ? { telephone: kennel.phone } : {}),
    ...(kennel.email ? { email: kennel.email } : {}),
    image: kennel.image,
  }
}

export const ORGANIZATION_JSON_LD = {
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Pawseum",
  url: SITE,
  logo: `${SITE}/assets/logo.webp`,
  sameAs: [],
  get description() {
    return i18n.t("utils:jsonLd.organizationDescription")
  },
  contactPoint: {
    "@type": "ContactPoint",
    contactType: "customer support",
    email: "pawseum@gmail.com",
  },
} as const
